import { apiClient } from '@/lib/api/api-client'
import type { FilterOption } from '@/lib/api/types'

export type GetUsersParams = {
  role?: string
  exclude_role?: string
}

export const apiGetUsers = (params?: GetUsersParams) => {
  const searchParams = new URLSearchParams()

  if (params?.role) {
    searchParams.set('role', params.role)
  }

  if (params?.exclude_role) {
    searchParams.set('exclude_role', params.exclude_role)
  }

  const query = searchParams.toString()

  return apiClient<FilterOption[]>(`/api/v1/users${query ? `?${query}` : ''}`)
}
